import { render, staticRenderFns } from "./materialItem.vue?vue&type=template&id=38d695d0&scoped=true&"
import script from "./materialItem.vue?vue&type=script&lang=js&"
export * from "./materialItem.vue?vue&type=script&lang=js&"
import style0 from "./materialItem.vue?vue&type=style&index=0&id=38d695d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d695d0",
  null
  
)

export default component.exports